import { Fragment } from 'react'
import PropTypes from 'prop-types'
import { VictoryLabel } from 'victory'
import Icon from 'beam/dist/Icon'

const AssociatedContactIcon = props => {
  const {
    datum: { contact, fill },
    x0,
    y,
    isCurrentContact,
    isClickable,
    openContact,
    iconSize,
  } = props

  const iconCoords = {
    x: x0 - iconSize,
    y: y - iconSize / 2,
  }

  //<rect> and <g> exist to keep the element the same size for the tooltip so that there isn't thrashing
  return (
    <Fragment>
      <g style={{ cursor: isClickable ? 'pointer' : 'default' }}>
        <rect
          {...iconCoords}
          width={iconSize}
          height={iconSize}
          style={{ stroke: 'transparent', fill: 'transparent' }}
        />
        <Icon
          style={{ color: fill }}
          {...iconCoords}
          fontSize="default"
          onClick={() => (isClickable ? openContact(contact.id) : () => {})}
          data-testid={
            isCurrentContact ? `associated-contact-${contact.id}-icon-current` : `associated-contact-${contact.id}-icon`
          }
        >
          {isClickable ? 'Play' : 'Person'}
        </Icon>
      </g>
      <VictoryLabel {...props} style={{ cursor: 'pointer', pointerEvents: 'none' }} />
    </Fragment>
  )
}
AssociatedContactIcon.propTypes = {
  datum: PropTypes.object,
  x0: PropTypes.number,
  y: PropTypes.number,
  isCurrentContact: PropTypes.bool,
  isClickable: PropTypes.bool,
  openContact: PropTypes.func,
  iconSize: PropTypes.number,
}

export default AssociatedContactIcon
